import { connect } from 'react-redux';
import Sidebar from './sidebar';
import { getVisibleOrders } from '../../reselect/order.selector';
import { printArticleList, finishRoutePlanning, editRoutePlanning, openRouteDialog } from '../../reducers/order.reducers';

const mapStateToProps = state => ({
  orders: getVisibleOrders(state),
  selectedMode: state.orders.selectedMode,
  isRoutePlanning: state.orders.routeplanning,
  isEPosPrinterEnabled: state.app.localSettings.useEposPrinter,
  localSettings: state.app.localSettings,
  productionPlaces: state.menu.productionPlaces,
});

const mapDispatchToProps = (dispatch) => ({
  printArticleList: (articles) => dispatch(printArticleList(articles)),
  editRoutePlanning: () => dispatch(editRoutePlanning()),
  finishRoutePlanning: () => dispatch(finishRoutePlanning()),
  openRouteDialog: () => dispatch(openRouteDialog()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
